var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "30px",
    viewBox: "0 0 28 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.17157288,11.1684271 L11.1715729,2.16842712 C12.73367,0.606329958 15.26633,0.606329958 16.8284271,2.16842712 L25.8284271,11.1684271 C26.5785726,11.9185726 27,12.9359883 27,13.9968542 L27,25.5115729 C27,26.6161424 26.1045695,27.5115729 25,27.5115729 C24.469567,27.5115729 23.9608592,27.3008592 23.5857864,26.9257864 L16.8284271,20.1684271 C15.26633,18.60633 12.73367,18.60633 11.1715729,20.1684271 L4.41421356,26.9257864 C3.63316498,27.706835 2.36683502,27.706835 1.58578644,26.9257864 C1.21071368,26.5507137 1,26.0420059 1,25.5115729 L1,13.9968542 C1,12.9359883 1.42142736,11.9185726 2.17157288,11.1684271 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,29 C16.6862915,29 14,26.3137085 14,23 L14,23 L14,23 C14,26.3137085 11.3137085,29 8,29 L8,29 L8,29"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.418872479f53245ccaced96874f220ee.svg";
export { ForwardRef as ReactComponent };